import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getTier, refreshMe } from "../services/api";

export default function BillingSuccessPage() {
  const [tier, setTier] = useState(getTier());
  const [refreshing, setRefreshing] = useState(true);

  // The webhook usually fires before the redirect lands here, but not
  // always. Poll /auth/me a few times to pick up the new tier.
  useEffect(() => {
    let cancelled = false;
    let attempt = 0;
    const tick = async () => {
      attempt += 1;
      try {
        const me = await refreshMe();
        if (cancelled) return;
        const t = me.subscription_tier || "free";
        setTier(t);
        if (t === "pro" || t === "business" || attempt >= 6) {
          setRefreshing(false);
          return;
        }
      } catch {
        // ignore — we'll retry
      }
      if (!cancelled && attempt < 6) setTimeout(tick, 1500);
      else if (!cancelled) setRefreshing(false);
    };
    tick();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="page">
      <div className="card" style={{ maxWidth: 520, margin: "60px auto", textAlign: "center" }}>
        <h1 style={{ marginTop: 0 }}>🎉 You're upgraded!</h1>
        <p>
          Thanks for subscribing. Your account is now on the{" "}
          <b style={{ textTransform: "capitalize" }}>{tier}</b> plan.
        </p>
        {refreshing && (
          <p className="muted">Activating new features…</p>
        )}
        <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 16, flexWrap: "wrap" }}>
          <Link to="/reports" className="btn">Go to Reports</Link>
          <Link to="/" className="btn secondary">Back to dashboard</Link>
        </div>
      </div>
    </div>
  );
}
